export const menu = {
    state: {
        menuStatus: false
    },
    mutations: {
        TOGGLE_MENU(state, notification) {
            state.menuStatus = !state.menuStatus
        },
        HIDE_MENU(state, notification) {
            state.menuStatus = false
        }
    },
    actions: {
        toggleMenu({ commit }) {
            commit('TOGGLE_MENU')
        },
        hideMenu({ commit }) {
            commit('HIDE_MENU')
        }
    },
    getters: {
        menuStatus: (state) => {
            return state.menuStatus
        }
    }
}
